import { forwardRef } from 'react'
import { cn } from '@/lib/utils'
import { Tabs } from '../ui/Tabs'

// Main TopBar component - simplified structure
const TopBar = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <header
      ref={ref}
      className={cn(
        'sticky left-0 shrink-0',        
        'z-[4000] px-4',
        'transition-all duration-300 ease-out',
        className,
      )}
      {...props}
    >
      {children}
    </header>
  )
})
TopBar.displayName = 'TopBar'

// Title component
const TopBarTitle = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <h1
      ref={ref}
      className={cn(
        'font-taurus text-xl font-bold',
        'text-black',
        'tracking-tight capitalize',
        'flex-shrink-0',
        className,
      )}
      {...props}
    >
      {children}
    </h1>
  )
})
TopBarTitle.displayName = 'TopBar.Title'

// Actions container
const TopBarActions = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center gap-3',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
})
TopBarActions.displayName = 'TopBar.Actions'

// Export compound component
TopBar.Title = TopBarTitle
TopBar.Actions = TopBarActions
TopBar.Tabs = Tabs

export default TopBar
export { TopBar, TopBarActions, TopBarTitle }
